import { EVENT_STATUS } from '../../constants/event';

export function isLiveOrComing(event) {
    return [EVENT_STATUS.LIVE, EVENT_STATUS.COMING].includes(event.status);
}

export default function sortEvents(events, activeLiveEvent = {}) {
    return events.sort((a, b) => {
        if(activeLiveEvent && activeLiveEvent.id){
            if (a.id === activeLiveEvent.id) return -1;
            if (b.id === activeLiveEvent.id) return 1;
        }

        if (isLiveOrComing(a) && !isLiveOrComing(b)) return -1;
        if (!isLiveOrComing(a) && isLiveOrComing(b)) return 1;

        return 0;
    });
}
